
import { useEffect } from 'react';

interface WebVital {
  name: string;
  value: number;
  rating: 'good' | 'needs-improvement' | 'poor';
}

// Add gtag type declaration
declare global {
  function gtag(...args: any[]): void;
}

const WebVitalsTracker = () => {
  useEffect(() => {
    // Only load web vitals in production and not on Lovable domains
    const isLovableDomain = window.location.hostname.includes('lovableproject.com') || 
                           window.location.hostname.includes('lovable.app');
    
    if (process.env.NODE_ENV === 'production' && !isLovableDomain) {
      import('web-vitals').then((webVitals) => {
        const sendToAnalytics = (metric: WebVital) => {
          // Send to Google Analytics 4
          if (typeof gtag !== 'undefined') {
            gtag('event', metric.name, {
              value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
              event_category: 'Web Vitals',
              event_label: metric.rating,
              non_interaction: true,
            });
          }
          
          // Log for debugging in development only
          if (process.env.NODE_ENV === 'development') {
            console.log(`${metric.name}: ${metric.value} (${metric.rating})`);
          }
        };

        // Use correct web-vitals v4 API
        webVitals.onCLS(sendToAnalytics);
        webVitals.onINP(sendToAnalytics); // INP replaced FID in web-vitals v4
        webVitals.onFCP(sendToAnalytics);
        webVitals.onLCP(sendToAnalytics);
        webVitals.onTTFB(sendToAnalytics);
      });
    }
  }, []);

  return null;
};

export default WebVitalsTracker;
